import React from "react";
import { PrimaryButton } from "components/mui-styled-components";
import { useTheme } from "@mui/material/styles";
import { useDispatch, useSelector } from "react-redux";
import { actions, selectors } from "rdx";
import LeadToProposalDrawer from "containers/Sales/projects/components/LeadToProposalDrawer";
import useNavigation from "hooks/useNavigation";
import { useHistory } from "react-router-dom";
import SessionClient from "util/SessionClient";
import { userIsPowurEnergyLapsedFromSession } from "lib/helpers/auth";

type AddLeadButtonPropsT = {
  gradient?: boolean;
};

const AddLeadButton = ({ gradient = false }: AddLeadButtonPropsT) => {
  const theme = useTheme();
  const isL2pDrawerOpen = useSelector(selectors.selectLeadToProposalDrawerVisible);
  const history = useHistory();
  const dispatch = useDispatch();
  const { location } = history;
  const currentPath = location.pathname.substring(1);
  const { navigate, override } = useNavigation(currentPath, []);
  const session = new SessionClient();

  if (userIsPowurEnergyLapsedFromSession(session)) return null;

  const handleAddLeadClick = () => {
    dispatch(actions.setLeadToProposalDrawerVisible(true));
  };

  return (
    <>
      <PrimaryButton
        gradient={gradient}
        onClick={handleAddLeadClick}
        width="105px"
        height="34px"
        sx={{
          boxShadow: "none",
          "&:hover": {
            boxShadow: "none",
            backgroundColor: theme.colors["banner-blue-highlighted"],
          },
        }}
      >
        + New Lead
      </PrimaryButton>
      {isL2pDrawerOpen && <LeadToProposalDrawer key="lead-to-proposal" navigate={navigate} override={override} />}
    </>
  );
};

export default AddLeadButton;
